import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import {Container, Grid} from '@material-ui/core';
import Fade from '@material-ui/core/Fade';
import {ImagesCarousel} from "../index";

const useStyles = makeStyles((theme) => ({
  modal: {
    // display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'center',
    // backgroundColor:'orange'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    // padding: 10,
    borderRadius: 20
  },
  content: {
    // padding: theme.spacing(4, 15, 5, 15),
    // backgroundColor:'gray'
    padding:20
  }
}));

const data=[
  {id:2},
  {id:2},
  {id:2},
  {id:2},
]

export default function MakeOfferModal(props) {
  const classes = useStyles();
  const {open, setOpen, state={}, setState} = props
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}

        open={open}
        onClose={handleClose}
        // closeAfterTransition
        // BackdropComponent={Backdrop}
        BackdropProps={{
          // timeout: 500,
        }}
      >
        <Fade in={open}>
          <Container component="main" maxWidth="lg" >
            <div className={classes.paper}>
              <p className=' width-max-content float-right mouse-pointer pt-10 pr-20 font-18 error-class'
                 onClick={() => {
                   handleClose()
                 }}
              >X</p>
              <div className={classes.content}>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className=" mt-20 "
                  style={{
                    backgroundColor: "#F0F0F0",
                    paddingTop: "2%",
                    paddingBottom: "0%",
                  }}
                >
                  <ImagesCarousel data={data}/>
                </Grid>
              </div>
            </div>
          </Container>
        </Fade>
      </Modal>
    </div>
  );
}
